'use client';
import { ReactNode } from 'react';

import { ThemeProvider } from 'styled-components';

import { HeaderVisibilityStoreProvider } from '@providers/header-visibility-store-provider';
import { StoreProviders } from '@providers/StoreProviders';
import { GlobalStyles, lightTheme } from '@styles/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAxe } from 'hooks/useAxe';
import { Resource } from 'i18next';

import { ErrorHandler } from '@components/Error';
import { TranslationsProvider } from '@components/TranslationsProvider';

export interface ClientProvidersProps {
  locale: string;
  children: ReactNode;
  resources: Resource;
  namespaces: string[];
}

export const ClientProviders = ({
  children,
  locale,
  resources,
  namespaces,
}: ClientProvidersProps) => {
  const queryClient = new QueryClient();
  useAxe();

  return (
    <ErrorHandler>
      <TranslationsProvider locale={locale} resources={resources} namespaces={namespaces}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={lightTheme}>
            {/* To apply other store providers, add them to the array */}
            <StoreProviders providers={[HeaderVisibilityStoreProvider]}>
              <GlobalStyles />
              {children}
            </StoreProviders>
          </ThemeProvider>
        </QueryClientProvider>
      </TranslationsProvider>
    </ErrorHandler>
  );
};
